import { INCIDENT_TYPE } from 'containers/CourtManagerLegalProceedings/JudgementOnMerits/constants';
import { get, isEmpty } from 'lodash';

export const getCivilJudgement = (
  expertises: any = [],
  civj: any,
  item: any,
  incidentType: string,
) => {
  const incidentId =
    incidentType === INCIDENT_TYPE.VEHICLE ? 'vehiculeId' : 'victimId';

  if (get(civj, 'id')) {
    return (
      (!isEmpty(expertises) &&
        expertises.find((el: any) => {
          return (
            el?.id === get(civj, 'id') &&
            item?.id === get(civj, `${incidentId}`)
          );
        })) ||
      {}
    );
  } else {
    return (
      (!isEmpty(expertises) &&
        expertises.find((el: any) => {
          return (
            get(el, `${incidentId}`) === get(civj, `${incidentId}`) &&
            !el.id &&
            el?.expertiseJudgementAddDocumentId ===
              get(civj, 'expertiseJudgementAddDocumentId')
          );
        })) ||
      {}
    );
  }
};
